import { render, staticRenderFns } from "./bfexpansion.vue?vue&type=template&id=06110fd2&scoped=true&"
import script from "./bfexpansion.vue?vue&type=script&lang=js&"
export * from "./bfexpansion.vue?vue&type=script&lang=js&"
import style0 from "./bfexpansion.vue?vue&type=style&index=0&id=06110fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06110fd2",
  null
  
)

export default component.exports